<template>
  <div>
    <div class="hero signal-bg">
      <div class="inner">
        <h1 v-html="$t('autoTradingSignalPage.text1')">
          
        </h1>
        <h5 class="subtitle">{{$t('autoTradingSignalPage.text2')}}</h5>
      </div>
    </div>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('autoTradingSignalPage.text3')}}</h2>
				<div class="spacer"></div>
				<div class="col3-grid text-left white-bg">
          <div class="col3-grid-item">
            <div><img class="image-icon" src="@/assets/icons/signal-icon1.png" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text4')}}</h5>
						<p>{{$t('autoTradingSignalPage.text5')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img class="image-icon" src="@/assets/icons/signal-icon2.png" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text6')}}</h5>
						<p>{{$t('autoTradingSignalPage.text7')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img class="image-icon" src="@/assets/icons/signal-icon3.png" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text8')}}</h5>
						<p>{{$t('autoTradingSignalPage.text9')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 dark">
      <div class="section-inner">
				<SignalSlider />
			</div>
    </section>

    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">{{$t('autoTradingSignalPage.text10')}}</h2>
				<div class="spacer"></div>
				<div class="col4-grid text-left">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/signal-icon4.svg" alt="" /></div>
            <h5>{{$t('autoTradingSignalPage.text11')}}</h5>
            <ul class="col-list">
							<li>{{$t('autoTradingSignalPage.text12')}}</li>
							<li>{{$t('autoTradingSignalPage.text13')}}</li>
							<li>{{$t('autoTradingSignalPage.text14')}}</li>
							<li>{{$t('autoTradingSignalPage.text15')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/signal-icon5.svg" alt="" /></div>
            <h5>{{$t('autoTradingSignalPage.text16')}}</h5>
            <ul class="col-list">
							<li>{{$t('autoTradingSignalPage.text17')}}</li>
							<li>{{$t('autoTradingSignalPage.text18')}}</li>
							<li>{{$t('autoTradingSignalPage.text19')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/signal-icon6.svg" alt="" /></div>
            <h5>{{$t('autoTradingSignalPage.text20')}}</h5>
            <ul class="col-list">
							<li>{{$t('autoTradingSignalPage.text21')}}</li>
							<li>{{$t('autoTradingSignalPage.text22')}}</li>
						</ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/signal-icon7.svg" alt="" /></div>
            <h5>{{$t('autoTradingSignalPage.text23')}}</h5>
            <ul class="col-list">
							<li>{{$t('autoTradingSignalPage.text24')}}</li>
							<li>{{$t('autoTradingSignalPage.text25')}}</li>
							<li>{{$t('autoTradingSignalPage.text26')}}</li>
						</ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 orange">
      <div class="section-inner">
        <h2 class="section-title">{{$t('autoTradingSignalPage.text27')}}</h2>
				<div class="spacer"></div>
				<div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/signal-icon8.svg" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text28')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/signal-icon9.svg" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text29')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/signal-icon10.svg" alt=""></div>
            <h5>{{$t('autoTradingSignalPage.text30')}}</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title" v-html="$t('autoTradingSignalPage.text31')"></h2>
        <p>{{$t('autoTradingSignalPage.text32')}}</p>
      </div>
    </section>

    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('autoTradingSignalPage.text33')}}</h2>
        <p>{{$t('autoTradingSignalPage.text34')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';
import SignalSlider from '../components/SignalSlider.vue';

export default {
  name: 'AutoTradingSignalPage',
  components: { 
		BtnPrimary,
		SignalSlider
	},
  data() {
    return {};
 
   },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
